export interface PageImageConfig {
  label: string;
  image: string;
  color?: string;
  accessoryImage?: string;
  accessoryPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  accessoryText?: {
    line1: string;
    line2: string;
    line3?: string;
  };
}

// Navigation image map used across the landing navigation and overlays
export const mainNavImages: Record<string, PageImageConfig> = {
  services: {
    label: 'Services',
    image: '/assets/COVER.jpg',
    color: '#FDD452',
    accessoryImage: '/images/blog/ethos.jpg',
    accessoryPosition: 'top-right',
    accessoryText: {
      line1: 'Ship at velocity',
      line2: 'Turbo Labs Services',
      line3: 'Prototypes to production in weeks',
    },
  },
  about: {
    label: 'About',
    image: '/hero-images/hero-2.jpg',
    color: '#41142A',
    accessoryImage: '/images/blog/ai-team.png',
    accessoryPosition: 'bottom-left',
    accessoryText: {
      line1: 'People first',
      line2: 'Culture of builders',
    },
  },
  work: {
    label: 'Work',
    image: '/case-studies/case-study.png',
    color: '#160C19',
    accessoryImage: '/images/blog/ai-workforce-featured.png',
    accessoryPosition: 'bottom-right',
    accessoryText: {
      line1: 'Case studies',
      line2: 'Enterprise impact',
    },
  },
  insights: {
    label: 'Insights',
    image: '/images/blog/turbonium.png',
    color: '#41142A',
  },
  methodology: {
    label: 'Methodology',
    image: '/navigation/landing.png',
    color: '#FDD452',
  },
  demos: {
    label: 'Demos',
    image: '/images/blog/ai-workforce-featured.png',
    color: '#F92E5F',
  },
  blog: {
    label: 'Latest News',
    image: '/images/blog/ai-workforce-featured.png',
    color: '#160C19',
  },
  contact: {
    label: 'Contact',
    image: '/navigation/landing.png',
    color: '#FCAD55',
  },
  mach: {
    label: 'Mach',
    image: '/hero-images/hero-4.jpg',
    color: '#F92E5F',
  },
  nexus: {
    label: 'Nexus',
    image: '/images/blog/ai-team.png',
    color: '#41142A',
  },
};

export const caseStudyImages: Record<string, PageImageConfig> = {
  'case-studies/gravitate-energy': {
    label: 'Gravitate Energy',
    image: '/case-studies/case-study.png',
    color: '#F92E5F',
  },
  'case-studies/momentum-ai': {
    label: 'Momentum AI',
    image: '/images/blog/ai-team.png',
    color: '#41142A',
  },
  'case-studies/velvette-night': {
    label: 'Velvette Night',
    image: '/images/blog/ai-workforce-featured.png',
    color: '#160C19',
  },
  work: {
    label: 'All Work',
    image: '/case-studies/case-study.png',
    color: '#FCAD55',
  },
};

export const allPageImages = {
  ...mainNavImages,
  ...caseStudyImages,
};

export const getPageImage = (label: string): PageImageConfig | undefined => {
  return allPageImages[label];
};
